/** Alpha antialiasing: how a BaseMaterial3D cutout turns its alpha into an edge that MSAA smooths. */
import { enumNamesByValue, relabelEnumNames } from '../../classdb/enumNames';
import { clamp } from '../../math/math';
/**
 * `BaseMaterial3D::AlphaAntiAliasing` (`scene/resources/material.h:196-200`), as the integers a
 * `.tscn` stores for `alpha_antialiasing_mode`. SpriteBase3D and Label3D store the same enum.
 */
export const AlphaAntiAliasing = {
    ALPHA_ANTIALIASING_OFF: 0,
    ALPHA_ANTIALIASING_ALPHA_TO_COVERAGE: 1,
    ALPHA_ANTIALIASING_ALPHA_TO_COVERAGE_AND_TO_ONE: 2,
};
/**
 * A scissor cutout's alpha antialiasing, or null while the mode is OFF. The edge sits past the
 * threshold, "otherwise we won't get any edge feather" (`scene_forward_clustered.glsl:1419-1422`).
 */
export function scissorAntialiasing(mode, scissorThreshold, edge) {
    if (mode === AlphaAntiAliasing.ALPHA_ANTIALIASING_OFF)
        return null;
    return { mode, scissorThreshold, edge: clamp(scissorThreshold + edge, 0, 1) };
}
/** A hash cutout's alpha antialiasing, or null while the mode is OFF. Its edge is not clamped. */
export function hashAntialiasing(mode, edge) {
    if (mode === AlphaAntiAliasing.ALPHA_ANTIALIASING_OFF)
        return null;
    return { mode, scissorThreshold: 0, edge };
}
/**
 * Whether the mode turns alpha to coverage on, with the blend that goes with it. Only the two named
 * modes emit a render mode (`material.cpp:905-912`, `scene_shader_forward_clustered.cpp:104-105`).
 */
export function turnsOnAlphaToCoverage(mode) {
    return (mode === AlphaAntiAliasing.ALPHA_ANTIALIASING_ALPHA_TO_COVERAGE ||
        mode === AlphaAntiAliasing.ALPHA_ANTIALIASING_ALPHA_TO_COVERAGE_AND_TO_ONE);
}
/** Each mode's name by the integer a `.tscn` stores, as the BaseMaterial3D validator prints it. */
export const ALPHA_ANTIALIASING_NAMES = enumNamesByValue(AlphaAntiAliasing);
/** Each mode's name without its `ALPHA_ANTIALIASING_` prefix, as the Label3D and Sprite3D validators print it. */
export const ALPHA_ANTIALIASING_SHORT_NAMES = relabelEnumNames(ALPHA_ANTIALIASING_NAMES, (name) => name.replace(/^ALPHA_ANTIALIASING_/, ''));
//# sourceMappingURL=alphaAntialiasing.js.map